import { InjectionToken } from '@angular/core';
import { IDateService } from './date-service.interface';

export const DATE_SERVICE = new InjectionToken<IDateService>('DATE_SERVICE');
